import InputBase from "@material-ui/core/InputBase";
import { fade, makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import React, { useState } from "react";

const useStyles = makeStyles((theme) => ({
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
  inputError: {
    color: "#d0d0d0",
  },
}));

export const SearchField = ({ searchCallback, initialText }) => {
  const MinNeedleLength = 3;
  const classes = useStyles();
  const [state, setState] = useState(initialText);

  const handleKeypress = (event) => {
    if (state && event.key === "Enter" && state.length > MinNeedleLength) {
      event.preventDefault();
      searchCallback(state);
    }
  };

  const isError = (s) => s && s.length != 0 && s.length < MinNeedleLength;

  return (
    <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <InputBase
        error={isError(state)}
        placeholder="Search…"
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
          error: classes.inputError,
        }}
        inputProps={{ "aria-label": "search" }}
        onChange={(event) => setState(event.target.value)}
        onKeyPress={handleKeypress}
        value={state}
      />
    </div>
  );
};
